<template>
  <div class="">
    <div class="center">
      <el-dialog
        id="mapWrap"
        center
        :close-on-click-modal="false"
        :visible.sync="shut"
        :title="'经销商选择'"
        @close="shut = false"
        width="1400px"
      >
        <baidu-map class="map" :ak="BaiduKey" :center="center" :zoom="zoom" :scroll-wheel-zoom="true">
          <bm-view style="width: 100%; height: 100%; flex: 1"></bm-view>
          <bm-local-search
            :keyword="keyword"
            :location="province + city"
            :panel="false"
            :selectFirstResult="true"
            forceLocal
            autoViewport
            @searchcomplete="searchComplete"
          ></bm-local-search>
          <BmMarker v-show="makerPosition.lng && makerPosition.lat" :position="makerPosition" :dragging="false" />
          <bm-navigation anchor="BMAP_ANCHOR_TOP_LEFT"></bm-navigation>
        </baidu-map>
        <div class="main">
          <div class="select">
            <el-cascader
              placeholder="选择省/市"
              :options="options"
              @change="handleChange"
              :separator="' '"
              v-model="defaultD"
            />
          </div>
          <ul>
            <el-radio-group v-model="radio" fill="#C6001F">
              <li v-for="(e, i) in list" :key="e.id" @click="radioChange(i)">
                <div class="liLeft">
                  <elRadio :label="i"></elRadio>
                </div>
                <div class="liRight">
                  <p class="name">{{ e.name }}</p>
                  <p>地址&nbsp;:&nbsp;{{ e.details }}</p>
                  <p>电话&nbsp;:&nbsp;{{ e.extAttributes && e.extAttributes.salesPhone }}</p>
                </div>
                <div class="distance">
                  <img :src="LocationImg" />
                  {{ transDistanceUnit(e.gpsDistance) }}
                </div>
              </li>
            </el-radio-group>
          </ul>
          <div class="cancel">
            <div @click="shut = false">取消</div>
            <div @click="confirm" class="confirm">确认</div>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script type="text/javascript">
// import { Dialog, Cascader, Radio, RadioGroup } from 'element-ui'
import { BaiduMap, BmView, BmLocalSearch, BmNavigation, BmMarker } from 'vue-baidu-map'
import LocationImg from '@/assets/location.png'
import { provinceAndCityData } from 'element-china-area-data'
import { getStorage, transDistanceUnit, getBaiduKey, _debounce } from '@/lib/utils'
import getData from '@/api/details'

/*
参数
    :show  控制弹窗弹出
    :sellOf   车型
    @dealerData  经销商数据
 */
export default {
  name: 'distributor',
  data() {
    return {
      tempdefaultDealerId: '',
      makerPosition: { lat: 30.252163, lng: 118.202971 },
      BaiduKey: getBaiduKey(),
      lng: null,
      lat: null,
      LocationImg,
      shut: false,
      options: provinceAndCityData,
      center: { lng: 0, lat: 0 },
      // center: '安徽省芜湖市',
      zoom: 11.5,
      keyword: [],
      keywordInit: [],
      city: '芜湖市',
      province: '安徽省',
      cityId: 340200,
      list: [],
      radio: '',
      data: '',
      defaultD: ['340000', '340200']
    }
  },
  props: {
    show: {
      default: false
    },
    sellOf: {
      default: '',
      required: true
    },
    isNewretail: {
      default: ''
    },
    codes: {
      required: Array
    }
  },
  watch: {
    show(e) {
      this.shut = e
    },
    shut(e) {
      this.$emit('update:show', e)
    },
    sellOf() {
      this.getList({
        cityCode: this.cityId,
        sellOf: this.sellOf
      })
    },
    keywordInit(newV, oldV) {
      if (!newV) return
      let initNewV = []
      if (typeof newV === 'object') initNewV = [...newV]
      newV = typeof newV === 'object' ? newV.join(',') : newV
      oldV = typeof oldV === 'object' ? oldV.join(',') : oldV

      if (newV !== oldV) {
        this.changeKeyword(initNewV, this)
      }
    }
  },
  components: {
    // elDialog: Dialog,
    // elCascader: Cascader,
    // elRadio: Radio,
    // elRadioGroup: RadioGroup,
    BaiduMap,
    BmView,
    BmLocalSearch,
    BmNavigation,
    BmMarker
  },
  methods: {
    transDistanceUnit,
    changeKeyword: _debounce((val, scope) => {
      scope.keyword = val
    }, 100),
    searchComplete(e) {
      this.keywordInit = ''
      this.keyword = ''
      if (e && e[0] && e[0].Hr) {
        if (!e[0].Hr[0]) {
          this.$feedback('该地址没有搜索结果')
          return
        }
        const address = e[0].Hr[0]
        this.makerPosition = address.point
      }
    },
    confirm() {
      this.$emit('dealerData', this.data)
      this.shut = false
    },

    getProCity(arrCodeProCity, notSetCenter) {
      let obj = { pro: '', city: '' }
      // 获取省市名称
      provinceAndCityData.forEach((pro) => {
        if (pro.value === arrCodeProCity[0]) {
          obj.pro = pro.label
          pro.children.forEach((city) => {
            if (city.value === arrCodeProCity[1]) obj.city = city.label
          })
        }
      })
      this.province = obj.pro
      this.city = obj.city
      if (!notSetCenter) {
        this.center = this.province + this.city
      }
      return obj
    },

    handleChange(value) {
      this.radio = ''
      this.cityId = value[1]
      // 获取省市名称
      provinceAndCityData.forEach((pro) => {
        if (pro.value === value[0]) {
          this.province = pro.label
          pro.children.forEach((city) => {
            if (city.value === value[1]) this.city = city.label
          })
        }
      })
      // 获取省市名称
      this.getProCity(value)

      this.keywordInit = []
      this.getList({
        cityCode: this.cityId,
        sellOf: this.sellOf
      })
    },
    getList(map, defaultDealerId) {
      if (defaultDealerId && defaultDealerId !== '') {
        this.tempdefaultDealerId = defaultDealerId
      }

      if (this.lat && this.lng) {
        map.gpsLongitude = this.lng
        map.gpsLatitude = this.lat
      }
      let codes = []
      codes = this.codes
      let maps = {
        codes: codes,
        cityCode: map.cityCode,
        gpsLatitude: map.gpsLatitude,
        gpsLongitude: map.gpsLongitude,
        sellOf: map.sellOf
      }
      getData.getAddress(maps).then((res) => {
        if (res.status) {
          if (this.isNewretail === 'true') {
            this.list = res.data.filter((item) => item.extAttributes.dealerType === '1')
            // dealerType 新零售为1 ,普通为0 也可能没有此字段
          } else {
            this.list = res.data
          }
          this.keywordInit = []
          if (res.data && res.data.length) {
            let firstAddress = res.data[0]
            if (this.data.details) this.keywordInit.push(firstAddress.details)
            else if (this.data.name) this.keywordInit.push(firstAddress.name)
            // this.keywordInit.push(firstAddress.details);
            // this.keywordInit.push(firstAddress.name);
          }
          if (this.tempdefaultDealerId && this.tempdefaultDealerId !== '') {
            this.initSetDealer(this.tempdefaultDealerId)
          }
        }
      })
    },
    radioChange(index) {
      this.radio = index
      this.data = this.list[index]
      this.keywordInit = []
      // 组合地址和店名来搜索
      // this.keywordInit.push('浙江省杭州市西湖区中大银座')
      if (this.data.details) this.keywordInit.push(this.data.details)
      else if (this.data.name) this.keywordInit.push(this.data.name)
    },
    /**
     * 设置默认经销商
     */
    initSetDealer(dealerId) {
      this.data = this.list.filter((o) => {
        return o.id === dealerId
      })[0]
      this.$emit('dealerData', this.data)
    },
    getActicityDealerList(defaultDealerId) {
      this.getList(
        {
          cityCode: this.cityId,
          sellOf: this.sellOf
        },
        defaultDealerId
      )
    }
  },
  mounted() {
    let code = getStorage('dtmAdcode')
    let lng = getStorage('dtmLng')
    let lat = getStorage('dtmLat')
    if (code) {
      this.cityId = ('' + code).slice(0, 4).padEnd(6, '0')
      this.center.lng = lng
      this.center.lat = lat
      this.lng = lng
      this.lat = lat
      this.defaultD[0] = this.cityId.slice(0, 2).padEnd(6, '0')
      this.defaultD[1] = this.cityId.slice(0, 4).padEnd(6, '0')
      // 初始化设置
      this.getProCity(this.defaultD, true)
    }
    // this.getList({
    //   cityCode: this.cityId,
    //   sellOf: this.sellOf
    // })
  }
}
</script>

<style scoped lang="scss">
.center {
  .map {
    width: 850px;
    height: 565px;
    float: left;
  }
  .main {
    float: left;
    width: 368px;
    margin-left: 38px;
    position: relative;
    height: 565px;
    .select {
      width: 100%;
      margin-top: 27px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    ul {
      width: 368px;
      margin-top: 20px;
      height: 360px;
      overflow-y: auto;
      &::-webkit-scrollbar {
        width: 10px;
        height: 1px;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        background: #535353;
      }
      &::-webkit-scrollbar-track {
        box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        border-radius: 10px;
        background: #ededed;
      }
      li {
        width: 368px;
        padding: 10px 0;
        overflow: hidden;
        border-bottom: 1px solid #999999;
        display: flex;
        align-items: left;
        cursor: pointer;
        .liLeft {
          width: 42px;
        }
        .distance {
          z-index: 999999;
          width: 80px;
          color: #666;
          margin-top: 10px;
          display: flex;
          font-size: 14px;
          img {
            width: 16px;
            height: 16px;
            margin-top: -2px;
          }
          p {
            color: #1f1f1f;
            width: 50px;
            font-size: 14px;
          }
          padding-right: 5px;
        }
        .liRight {
          width: 200px;
          p {
            font-size: 14px;
            line-height: 20px;
            margin-top: 8px;
            color: #999999;
          }
          .name {
            font-size: 16px;
            font-weight: 600;
            color: #333333;
          }
        }
      }
    }
    .cancel {
      width: 100%;
      position: absolute;
      bottom: 0;
      height: 92px;
      > div {
        float: left;
        width: 150px;
        height: 45px;
        border: 1px solid rgba(207, 207, 207, 1);
        text-align: center;
        line-height: 45px;
        margin-left: 20px;
        cursor: pointer;
      }
      .confirm {
        background: #1f1f1f;
        color: #fff;
      }
    }
  }
}
</style>
